import type { BoardOptionPreference, BoardStartIntent } from './types';

const INTENTS: readonly BoardStartIntent[] = ['generic', 'conventional', 'fha', 'bank_statement', 'dscr'];
const PREFERENCES: readonly BoardOptionPreference[] = ['balanced', 'lower_rate'];

/** Only categorical choices cross the public/private boundary. */
export function rateEntryUrl(intent: BoardStartIntent = 'generic', preference: BoardOptionPreference = 'balanced'): string {
  return `/rate-experience?${new URLSearchParams({ entry: 'options', intent, preference })}`;
}

export function parseRateEntry(query: URLSearchParams): { intent: BoardStartIntent; preference: BoardOptionPreference } | null {
  if (query.get('entry') !== 'options') return null;
  const intent = query.get('intent') ?? 'generic';
  const preference = query.get('preference') ?? 'balanced';
  if (!INTENTS.includes(intent as BoardStartIntent) || !PREFERENCES.includes(preference as BoardOptionPreference)) return null;
  return { intent: intent as BoardStartIntent, preference: preference as BoardOptionPreference };
}
